class TreeParameterSugarer {
  static sugarField(fieldName) {
    return fieldName;
  }
  static sugarHasOneRelation(fieldName, reducedBy, filter) {
    return `${fieldName}${this.sugarUniqueWhere(reducedBy)}${this.sugarFilter(filter)}`;
  }
  static sugarHasManyRelation(fieldName, filter) {
    return `${fieldName}${this.sugarFilter(filter)}`;
  }
  static sugarRootEntity(entityName, where) {
    return `${entityName}${this.sugarUniqueWhere(where)}`;
  }
  static sugarRootEntityList(entityName, filter) {
    return `${entityName}${this.sugarFilter(filter)}`;
  }
  static sugarUniqueWhere(where) {
    if (where === void 0) {
      return "";
    }
    return `(…)`;
  }
  static sugarFilter(filter) {
    if (filter === void 0) {
      return "";
    }
    return `[…]`;
  }
}
export {
  TreeParameterSugarer
};
//# sourceMappingURL=TreeParameterSugarer.js.map
